module.exports = " <div> <div class=form-group> <label for=name>Nombre</label> <input type=text v-model=award.name class=form-control> </div> <div class=form-group> <label for=name>Class</label> <input type=text v-model=award.class class=form-control> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/AwardsForm.vue
 ** module id = 299
 ** module chunks = 1
 **/